/**
 * Yotpo Rating Component
 * Handles Yotpo widget initialization and text cleanup for product cards.
 * Used by na-dressers-cribs section to show Yotpo star ratings.
 */

/**
 * Initialize Yotpo widgets on the page
 */
function initYotpoWidgets() {
    if (typeof window === 'undefined') return;

    // Yotpo's API to initialize widgets
    if (window.yotpoWidgetsContainer?.initWidgets) {
        window.yotpoWidgetsContainer.initWidgets();
    } else if (window.yotpo?.refreshWidgets) {
        window.yotpo.refreshWidgets();
    }
}

/**
 * Clean up Yotpo text to show only the number
 * Hides "Write a review" link and extracts just the review count
 */
function cleanupYotpoText() {
    const widgets = document.querySelectorAll('.na-yotpo-rating');

    widgets.forEach((widget) => {
        if (widget.classList.contains('na-yotpo-rating--embed')) return;

        const writeReview = widget.querySelector('.yotpo-sr-bottom-line-new-review');
        if (writeReview instanceof HTMLElement) {
            writeReview.style.display = 'none';
        }

        const textEl = widget.querySelector('.yotpo-sr-bottom-line-text');
        if (!textEl?.textContent) return;

        const text = textEl.textContent.trim();
        const match = text.match(/^(\d+)/);
        if (!match || match[1] === text) return;

        textEl.textContent = match[1];
    });
}

/**
 * Setup MutationObserver to watch for Yotpo DOM changes
 */
let yotpoObserver = null;

function observeYotpoWidgets() {
    const widgets = document.querySelectorAll('.na-yotpo-rating');
    if (widgets.length === 0) return;

    if (yotpoObserver) {
        yotpoObserver.disconnect();
    }

    yotpoObserver = new MutationObserver(() => {
        yotpoObserver.disconnect();
        cleanupYotpoText();
        observeYotpoWidgets();
    });

    widgets.forEach((widget) => {
        yotpoObserver.observe(widget, {
            childList: true,
            subtree: true,
            characterData: true,
        });
    });
}

function disconnectYotpoObserver() {
    yotpoObserver?.disconnect();
    yotpoObserver = null;
}

/**
 * Initialize when Yotpo is ready
 */
function onYotpoReady() {
    initYotpoWidgets();
    // Small delay to let Yotpo render
    setTimeout(() => {
        cleanupYotpoText();
        observeYotpoWidgets();
    }, 100);
}

/**
 * Main initialization
 * Waits for Yotpo script to load before initializing
 */
function init() {
    // If Yotpo is already loaded, initialize immediately
    if (window.yotpoLoaded || window.yotpo) {
        onYotpoReady();
        return;
    }

    // Wait for yotpo:loaded event (dispatched when script loads)
    document.addEventListener('yotpo:loaded', onYotpoReady, { once: true });

    // Fallback: check periodically for Yotpo availability
    let attempts = 0;
    const maxAttempts = 20;
    const checkInterval = setInterval(() => {
        attempts++;
        if (window.yotpoLoaded || window.yotpo) {
            clearInterval(checkInterval);
            onYotpoReady();
        } else if (attempts >= maxAttempts) {
            clearInterval(checkInterval);
        }
    }, 500);
}

document.addEventListener('pagehide', disconnectYotpoObserver);

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
